<div 
    *ngIf="threatDetails"
    class="fixed inset-0 flex items-center justify-center bg-main-background bg-opacity-75 z-20 gap-4"
    (click)="$event.preventDefault(); closeModal();"
>
    <div class="w-full max-w-screen-sm max-h-[90%] flex flex-row gap-1 justify-center" (click)="$event.stopPropagation()">
        <!-- THREAT DETAILS -->
        <div class="flex w-full bg-white p-10 w-1/4 rounded-md text-center shadow-lg">
            <div class="w-full flex flex-col items-center justify-start gap-4">
                <div class="w-full flex flex-row items-start justify-between gap-2">
                    <h2 class="min-w-0 flex-1 oswald-font text-xl font-medium text-start whitespace-pre-line break-words [overflow-wrap:anywhere]">
                        Threat:
                        <span class="text-nside-orange-400">{{ threatDetails.threat }}</span>
                    </h2>
                    <button
                        class="p-1 rounded-full hover:bg-gray-100"
                        (click)="$event.preventDefault(); closeModal();"
                    >
                        <lucide-icon [name]="icons.X" [size]="20" class="text-nside-gray-200"></lucide-icon>
                    </button>
                </div>
                <div class="w-full h-full flex flex-col items-center p-4 rounded-lg">
                    <div class="w-full flex items-center text-start p-2 bg-gray-100">
                        <div class="w-52 flex items-center text-nside-gray-300">
                            <p>Probability:</p>
                        </div>
                        <div class="w-full flex items-center">
                            <p>{{ threatDetails.probability }}</p>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start p-2">
                        <div class="w-52 flex items-center text-nside-gray-300">
                            <p>Magnitude:</p>
                        </div>
                        <div class="w-full flex items-center">
                            <p>{{ threatDetails.magnitude }}</p>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start p-2 bg-gray-100">
                        <div class="w-52 flex items-center text-nside-gray-300">
                            <p>Warning:</p>
                        </div>
                        <div class="w-full flex items-center">
                            <p>{{ threatDetails.warning }}</p>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start p-2">
                        <div class="w-52 flex items-center text-nside-gray-300">
                            <p>Duration:</p>
                        </div>
                        <div class="w-full flex items-center">
                            <p>{{ threatDetails.duration }}</p>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start p-2 bg-gray-100">
                        <div class="w-52 flex items-center text-nside-gray-300">
                            <p>Risk Priority:</p>
                        </div>
                        <div class="w-full flex items-center">
                            <p>{{ threatDetails.risk_priority }}</p>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start p-2">
                        <div class="w-52 flex items-center text-nside-gray-300">
                            <p>Last Updated By:</p>
                        </div>
                        <div class="w-full flex items-center">
                            <p>{{ threatDetails.last_updated_user_name }}</p>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start p-2 bg-gray-100">
                        <div class="w-52 flex items-center text-nside-gray-300">
                            <p>Last Updated At:</p>
                        </div>
                        <div class="w-full flex items-center">
                            <p>{{ threatDetails.last_updated_at | date: 'MM/dd/yyyy - HH:mm' }}</p>
                        </div>
                    </div>
                </div>

                <div class="w-full flex flex-row gap-2 items-center justify-end">
                    <button 
                        (click)="$event.preventDefault(); closeModal();"
                        class="px-4 py-1.5 w-20 rounded-md border border-nside-gray-400 oswald-font"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
        
    </div>
</div>